import { startCase, lowerCase } from 'lodash'
import * as serializers from '../../serializers'

export const common = serializers.application

export const walletList = (data) =>
  data.map((item) => ({
    groupName: item.groupName,
    id: item.id,
    nameFantasy: startCase(lowerCase(item.nameFantasy)),
    tabNumber: item.tabNumber.toString(),
    walletCode: item.walletCode.toString()
  }))

export const walletPagination = (metadata) => metadata.pagination

export const filtersSerialize = (filter) =>
  filter.map((item) => ({
    id: item.id || 'N/A',
    name: item.name || 'N/A'
  }))

export const getWallets = (res) => {
  const { data = {}, headers = {}, metadata = {} } = res

  const newData = data.map((item) => ({
    ...item,
    nameFantasy: startCase(lowerCase(item.nameFantasy)),
    tabNumber: item.tabNumber.toString()
  }))

  const newMeta = {}

  newMeta.pagination = {
    currentPage: metadata.pagination.currentPage,
    lastPage: metadata.pagination.lastPage,
    total: metadata.pagination.total
  }

  return {
    data: newData,
    headers,
    metadata: newMeta
  }
}
